import { ApiClient } from '../apiClient';
import { Review, CreateReviewDto, PaginatedReviewDto } from '../../types/review';

export class ReviewService {
  constructor(private apiClient: ApiClient) {}

  /**
   * Get reviews for a specific card
   */
  async getCardReviews(cardId: string): Promise<PaginatedReviewDto> {
    try {
      const result = await this.apiClient.post<PaginatedReviewDto>(`/gift/card/${cardId}/reviews`);
      return result;
    } catch {
      return {
        items: [],
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
      };
    }
  }

  /**
   * Submit a new review for a card
   */
  async submitReview(cardId: string, reviewData: CreateReviewDto): Promise<Review> {
    return await this.apiClient.post<Review>(`/gift/card/${cardId}/review`, reviewData);
  }
}
